import { combine, createEvent, sample } from 'effector'
import { register } from '~/core/repository'
import { model as sessionModel } from '~/entities/session'
import { tvPurchasedEntityModel } from '~/entities/tv/purchased'
import { nay } from '~/shared/helpers'
import { libraryGridPurchasedTvChannelsWidget } from '~/widgets/library/grid/purchased/tvChannels'
import { $libraryPurchasedTvChannelsTranslations } from './translations'

export const initLibraryPurchasedTvChannelsPage = createEvent()
export const leftLibraryPurchasedTvChannelsPage = createEvent()

sample({
  clock: initLibraryPurchasedTvChannelsPage,
  target: libraryGridPurchasedTvChannelsWidget.loadGridPurchasedTvChannels,
})

export const $isLibraryPurchasedTvChannelsEmptyPage = combine(
  tvPurchasedEntityModel.$purchasedTvChannelsGrid,
  (purchasedTvChannelsGrid) =>
    purchasedTvChannelsGrid && !purchasedTvChannelsGrid.content.length
)

sample({
  source: leftLibraryPurchasedTvChannelsPage,
  target: tvPurchasedEntityModel.resetPurchasedTvChannelsGrid,
})

sample({
  source: sessionModel.$authenticated,
  filter: nay,
  target: tvPurchasedEntityModel.resetPurchasedTvChannelsGrid,
})

register(
  $libraryPurchasedTvChannelsTranslations,
  '$libraryPurchasedTvChannelsTranslations'
)
register(
  tvPurchasedEntityModel.$purchasedTvChannelsGridFormatted,
  '$library/purchased/tvChannels/purchasedTvChannelsGridFormatted'
)
register(
  $isLibraryPurchasedTvChannelsEmptyPage,
  '$isLibraryPurchasedTvChannelsEmptyPage'
)
register(
  libraryGridPurchasedTvChannelsWidget.loadMoreGridPurchasedTvChannels,
  'loadMoreGridPurchasedTvChannels'
)
